<template>
  <div>
    <b-card>
      <b-row>
        <b-col md="3">
          <b-link :to="{ name: 'InvoiceInfo-View' }">
            <feather-icon icon="ArrowLeftIcon" />
            <span class="align-middle ml-50">Back to List</span>
          </b-link>
        </b-col>
      </b-row>

      <b-card-header>
        <h1>Invoice Information Detail Page</h1>
      </b-card-header>
      <b-card-body>
        <b-row>
          <b-col md="6">
            <h4 class="mb-2 text-decoration-underline">Company information</h4>
            <b-form-group>
              <strong>Company Name: </strong>
              <span>{{ detailInfo.company_name }}</span>
            </b-form-group>
            <b-form-group>
              <strong>Company Id: </strong>
              <span>{{ detailInfo.company_id }}</span>
            </b-form-group>
            <b-form-group>
              <strong>Company Code: </strong>
              <span>{{ detailInfo.company_code }}</span>
            </b-form-group>
            <b-form-group>
              <strong>Company Address: </strong>
              <span>{{ detailInfo.invoice_address.address }}</span>
            </b-form-group>
            <b-form-group>
              <strong>Company Telephone: </strong>
              <span>{{ detailInfo.invoice_address.telephone }}</span>
            </b-form-group>
            <b-form-group>
              <strong>Company Fax: </strong>
              <span>{{ detailInfo.invoice_address.fax }}</span>
            </b-form-group>
            <b-form-group>
              <strong>Company P.O.Box: </strong>
              <span>{{ detailInfo.invoice_address.po_box }}</span>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <h4 class="mb-2 text-decoration-underline">
              Bank Detail / Signatory person
            </h4>
            <b-form-group>
              <strong>Body statement: </strong>
              <span>{{ detailInfo.body_statement }}</span>
            </b-form-group>
            <b-form-group>
              <strong>Bank Name: </strong>
              <span>{{ detailInfo.bank_details.bank_name }}</span>
            </b-form-group>

            <b-form-group>
              <strong>Account Number: </strong>
              <span>{{ detailInfo.bank_details.account_number }}</span>
            </b-form-group>
            <b-form-group>
              <strong>Beneficiary Name: </strong>
              <span>{{ detailInfo.bank_details.beneficiary_name }}</span>
            </b-form-group>

            <b-form-group>
              <strong>Signatory Name: </strong>
              <span>{{ detailInfo.signatory.name }}</span>
            </b-form-group>
            <b-form-group>
              <strong>Signatory Position: </strong>
              <span>{{ detailInfo.signatory.position }}</span>
            </b-form-group>
            <b-form-group>
              <strong>Footer Note: </strong>
              <span>{{ detailInfo.footer_note }}</span>
            </b-form-group>
          </b-col>
        </b-row>
        <b-overlay :show="isLoading" no-wrap rounded="sm" />
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BCard,
  BCardBody,
  BCardHeader,
  BOverlay,
  BLink,
} from "bootstrap-vue";
import axios from "@axios";

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BCard,
    BCardBody,
    BCardHeader,
    BOverlay,
    BLink,
  },
  data() {
    return {
      isLoading: false,
      detailInfo: {
        company_id: 0,
        invoice_address: {
          address: "",
          telephone: "",
          fax: ``,
          po_box: ``,
        },
        bank_details: {
          bank_name: "",
          beneficiary_name: "",
          account_number: "",
        },
        signatory: {
          name: "",
          position: "",
        },
        body_statement: "",

        footer_note: "",
      },
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.isLoading = true;
      axios
        .get(
          `/Invoice/api/V1.0/Invoice/GetInvoiceInfo?CompanyId=${this.$route.params.id}`
        )
        .then((res) => {
          this.isLoading = false;
          this.detailInfo = res.invoiceInformation;
        })
        .catch((res) => {
          console.log(res);
          this.isLoading = false;
        });
    },
  },
};
</script>
<style scoped></style>
